<template>
    <div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-form label-width="100px">
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="筛选学生">
                                <el-select v-model="$parentInfo.Dialog_SellGrantShop.filter.student_id" placeholder="学生"
                                           clearable
                                           filterable remote
                                           :remote-method="handelSearchByStudentName"
                                           @change="handleInfo()">
                                    <el-option
                                            v-for="item in students"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="筛选合同ID">
                                <el-select v-model="$parentInfo.Dialog_SellGrantShop.filter.invoice_id" placeholder="合同"
                                           clearable
                                           filterable remote
                                           :remote-method="handelSearchByInvoiceId"
                                           @change="handleInfo()">
                                    <el-option
                                            v-for="item in invoices"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-table
                        :data="$parentInfo.Dialog_SellGrantShop.grantInvoices"
                        style="width: 100%"
                        size="middle"
                        :height="450"
                >
                    <el-table-column label="" width="65">
                        <template scope="scope">
                            <el-radio :label="scope.row.id" v-model="invoiceid" @change.native="handleSelectionChange(scope.$index,scope.row)">&nbsp</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="created_at" label="合同日期"></el-table-column>
                    <el-table-column prop="student_name" label="学生姓名"></el-table-column>
                    <el-table-column prop="id" label="合同编号"></el-table-column>
                </el-table>
                <div class="m-portlet__foot">
                    <!--分页-->
                    <div class="text-center">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="$parentInfo.Dialog_SellGrantShop.currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="$parentInfo.Dialog_SellGrantShop.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div style="text-align: right">
            <el-button size="mini" @click="handleAdd()">加入合同交付清单</el-button>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    export default {
        name: "Dialog_SellGrantShop",
        data() {
            return {
                invoiceid:'',
                templateSelection:'',
                students:[],
                invoices:[]
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInfo();
            this.handelSearchByStudentName();
            this.handelSearchByInvoiceId();
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleInfo(currentPage = 1){
                if (currentPage === 1) {
                    this.$parentInfo.Dialog_SellGrantShop.currentPage = 1
                }
                this.$parentInfo.Dialog_SellGrantShop.loading = true;
                this.$axios.get(store.state.server + '/getSellDispatchList?'+
                    'studentId='+this.$parentInfo.Dialog_SellGrantShop.filter.student_id +
                    '&invoiceId='+this.$parentInfo.Dialog_SellGrantShop.filter.invoice_id +
                    '&nameId='+this.$store.state.modal.data.name_id +
                    '&page='+this.$parentInfo.Dialog_SellGrantShop.currentPage +
                    '&limit=' + this.$parentInfo.Dialog_SellGrantShop.currentPageSize
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.$parentInfo.Dialog_SellGrantShop.grantInvoices=response.data.content.list
                        this.$parentInfo.Dialog_SellGrantShop.total=response.data.content.total
                        this.$parentInfo.Dialog_SellGrantShop.loading = false;
                    }
                })
            },
            handleInit(){

            },
            handleChange(){

            },
            handleSelectionChange(index,row) {
                this.templateSelection = row;
            },
            handleSizeChange(val) {
                this.$parentInfo.Dialog_SellGrantShop.currentPageSize = val;
                this.handleInfo(this.$parentInfo.Dialog_SellGrantShop.currentPage, this.$parentInfo.Dialog_SellGrantShop.currentPageSize)
            },
            handleCurrentChange(val) {
                this.$parentInfo.Dialog_SellGrantShop.currentPage = val;
                this.handleInfo(this.$parentInfo.Dialog_SellGrantShop.currentPage, this.$parentInfo.Dialog_SellGrantShop.currentPageSize)
            },
            handleAdd(){
                this.$axios.post(store.state.server + '/dispatchShop', {
                        'shopId':this.$store.state.modal.data.shopId,
                        'invoiceItemShopId':this.templateSelection.id
                    }
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.$set(this.$parentInfo.leaseInventory,response.data.content.shop.id,response.data.content.shop)
                        this.$message({
                            type: 'success',
                            message: '发放成功'
                        });
                        this.$Win.closeModal()
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handelSearchByStudentName(val=''){
                this.$axios.get(store.state.server + '/searchByStudentName?studentName=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.students=response.data.content.students
                    }
                })
            },
            handelSearchByInvoiceId(val=''){
                this.$axios.get(store.state.server + '/searchByInvoiceId?invoiceId=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.invoices=response.data.content.invoiceIds
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>